import { AppointmentDetails } from '@dreryk/egabinet-appointment-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { BackActionLocation } from '~libs.desktop.video-consultation';
import { patientPaths } from '~libs.desktop.shared.paths';

import { PatientFileLocationData } from '../common/common.types';

export const getPatientName = (patient: PatientSimple): string => {
   const { firstName, lastName, phoneNumber } = patient;

   if (firstName && lastName) {
      return `${firstName.asString()} ${lastName.asString()}`;
   }

   return firstName?.asString() || lastName?.asString() || phoneNumber?.asString() || '';
};

type EncounterModeVisitor = <ACCEPT>(visitor: {
   visitVideoConsultation: () => ACCEPT;
   visitOnSite: () => ACCEPT;
}) => ACCEPT;

export const encounterModeVisitor = (appointment: AppointmentDetails | null): EncounterModeVisitor => (visitor) => {
   if (appointment?.encounterMode === 'VIDEO_CONSULTATION') {
      return visitor.visitVideoConsultation();
   }

   return visitor.visitOnSite();
};

type AppointmentVisitor = <ACCEPT>(visitor: {
   withAppointment: (appointment: AppointmentDetails) => ACCEPT;
   withoutAppointment: () => ACCEPT;
}) => ACCEPT;

export const appointmentVisitor = (appointment: AppointmentDetails | null): AppointmentVisitor => (visitor) => {
   if (appointment) {
      return visitor.withAppointment(appointment);
   }

   return visitor.withoutAppointment();
};

export const getVideoConsultationPatientTemporaryDataLocation = (
   patientId: number,
   appointmentId: number
): BackActionLocation<PatientFileLocationData> => {
   return {
      path: patientPaths.getTemporaryDataPath(patientId),
      state: {
         data: {
            appointmentId: appointmentId,
            showAppointmentOutOfSchedule: false,
         },
      },
   };
};
